import type { UseToastOptions } from '@chakra-ui/react'
import { useMatches } from "@remix-run/react"

export function useToastMessage(): UseToastOptions {
    const matches = useMatches()
    const root = matches.find( match => match.id === 'root')
    return root?.data?.toastMessage
}